import * as React from 'react';
import { useTranslations } from 'next-intl';
import { Meta } from '@mentimeter/ragnar-ui/typography';
import { Link } from '@mentimeter/ragnar-ui/link';

function TermsLink(chunks: React.ReactNode) {
  return (
    <Link
      color="inherit"
      href="/terms"
      target="_blank"
      rel="noopener noreferrer"
    >
      {chunks}
    </Link>
  );
}

function PoliciesLink(chunks: React.ReactNode) {
  return (
    <Link
      color="inherit"
      href="/policies"
      target="_blank"
      rel="noopener noreferrer"
    >
      {chunks}
    </Link>
  );
}

export const Terms = () => {
  const t = useTranslations('authentication.legacy.authPackage');
  return (
    <Meta as="p" textAlign="center">
      {t.rich('form_disclaimer', {
        TermsLink,
        PoliciesLink,
      })}
    </Meta>
  );
};

export default Terms;
